import { styled, Box, IconButton, Button } from '@mui/material';

export const GlobalBannersContentBase = styled(Box)({
  position: 'absolute',
  bottom: 'auto',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: '100%',
  maxHeight: 'calc(100% - 64px)',
  outline: 'none',
  width: '100%',

  '@media print': {
    height: 'auto',
  },
});

export const GlobalBannersIconButtonBase = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isWhite',
})<{ isWhite?: boolean }>(({ isWhite }) => ({
  position: 'absolute',
  color: 'transparent',
  width: 30,
  height: 30,

  '&:hover': {
    backgroundColor: isWhite
      ? 'rgba(253, 250, 250, 0.53)'
      : 'rgba(60, 16, 127, 0.5)',
  },
}));

export const GlobalBannersButtonBase = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isWhite',
})<{ isWhite?: boolean }>(({ isWhite }) => ({
  position: 'absolute',
  borderRadius: '20px',
  borderWidth: 5,
  fontWeight: 'bold',
  color: 'transparent',
  borderColor: 'transparent',

  '&:hover': {
    backgroundColor: isWhite
      ? 'rgba(253, 250, 250, 0.53)'
      : 'rgba(60, 16, 127, 0.5)',
    color: 'transparent',
    borderColor: 'transparent',
  },
}));

export const GlobalBannersImgBase = styled('img')({
  width: '100%',
  height: '100%',
});
